import { getUiLocale } from './locale';
import { tx } from './pack';
import { countryDisplayName } from './countryLabel';

function looksChinese(text: string) {
  return /[\u4e00-\u9fff]/.test(text);
}

const SUGGEST_KEY: Record<string, [string, string]> = {
  paid: ['api.suggest.paid', '已付款'],
  pending: ['api.suggest.pending', '未付款'],
  enabled: ['api.suggest.enabled', '已创建'],
  increase: ['api.suggest.pointsIncrease', '积分增加'],
  shopify_flow: ['api.suggest.shopifyFlow', '流程触发奖励'],
  friend_claimed_reward: ['api.suggest.friendClaimed', '好友领取奖励'],
  referral_completed: ['api.suggest.referralDone', '推荐人推荐成功'],
  yahoo: ['api.suggest.yahoo', 'Yahoo系(yahoo,aol)'],
  microsoft: ['api.suggest.microsoft', '微软系(outlook,hotmail,msn,live)'],
  google: ['api.suggest.google', '谷歌(gmail)'],
  apple: ['api.suggest.apple', '苹果（icloud）'],
  gradeUp: ['api.suggest.gradeUp', '等级提升'],
  gradeDown: ['api.suggest.gradeDown', '等级下降'],
};

/**
 * getSuggestList 系统选项。
 * 店铺名、用户群名、商品名、商家自定义属性不译。
 */
export function suggestOptionLabel(
  item?: { id?: string; name?: string; value?: string } | null,
  field?: string
) {
  if (!item) {
    return '';
  }
  const raw = item.name || item.value || '';
  if (getUiLocale() === 'zh-CN') {
    return raw;
  }
  if (field === 'country' || field === 'country_code' || field === 'phone_country_code') {
    const matched = String(raw).match(/^([A-Z]{2})\s+(.*)$/);
    if (matched) {
      return countryDisplayName({
        countryAbbreviation: matched[1],
        countryName: raw,
      }) || raw;
    }
    return countryDisplayName({
      countryAbbreviation: String(item.value || ''),
      countryName: raw,
    }) || raw;
  }
  const key = String(item.id || item.value || '');
  const mapped = SUGGEST_KEY[key];
  if (mapped) {
    return tx(null, mapped[0], mapped[1]);
  }
  if ((field === 'has_tracking_info' || field === 'is_last_partial_fulfilled') && (key === '0' || key === '1')) {
    return key === '1'
      ? tx(null, 'api.suggest.yes', '是')
      : tx(null, 'api.suggest.no', '否');
  }
  if (field === 'vip_tier_event' && (key === '1' || key === '2')) {
    return key === '1'
      ? tx(null, 'api.suggest.gradeUp', '等级提升')
      : tx(null, 'api.suggest.gradeDown', '等级下降');
  }
  const slash = raw.lastIndexOf('/');
  if (slash > 0) {
    const left = raw.slice(0, slash).trim();
    const right = raw.slice(slash + 1).trim();
    if (right && looksChinese(left) && !looksChinese(right)) {
      return right;
    }
  }
  return raw;
}
